import { render } from "./HistoryAgreement.vue?vue&type=template&id=23ce9368&scoped=true"
const script = {}

import "./HistoryAgreement.vue?vue&type=style&index=0&id=23ce9368&scoped=true&lang=css"

import exportComponent from "F:\\unilearn\\unilearn-web-vue3\\node_modules\\.store\\vue-loader@16.8.3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23ce9368"]])

export default __exports__